import React from "react";
import "../style/cart.scss";
import Number from "./common/Number";

const money = (n) => `$${n.toFixed(2)}`;
export default function Cart({ items, setCart, subtotal, shop, go }) {
  const freight = items.length ? 9.9 : 0;
  return (
    <main className="cart-page">
      <header>
        <span className="eyebrow">YOUR BAG / {items.length} PRODUCTS</span>
        <h1>
          Your care <em>edit.</em>
        </h1>
      </header>
      {!items.length ? (
        <div className="empty">
          <h2>Your bag is waiting for a little care.</h2>
          <button className="solid" onClick={() => shop("All")}>
            BROWSE THE MARKET ↗
          </button>
        </div>
      ) : (
        <div className="cart-layout mx-auto max-w-container">
          <section>
            {items.map((item) => (
              <article key={item.key} className="space-y-4">
                <img src={item.images[0]} alt={item.title} />
                <div>
                  <span>
                    {item.vendor} · {item.sku}
                  </span>
                  <h2>{item.title}</h2>
                  <p>
                    {item.size} · {item.qty} units at {money(item.price)}
                  </p>
                  <div className="my-4">
                    <Number
                      id={item.id}
                      num={item.qty}
                      onChange={(amount) =>
                        setCart((all) =>
                          all.map((entry) =>
                            entry.key === item.key
                              ? {
                                  ...entry,
                                  qty: Math.max(1, entry.qty + amount),
                                }
                              : entry,
                          ),
                        )
                      }
                    />
                  </div>
                  <button
                    className="text-xs"
                    onClick={() =>
                      setCart((all) => all.filter((x) => x.key !== item.key))
                    }
                  >
                    REMOVE
                  </button>
                </div>
                <b>{money(item.price * item.qty)}</b>
              </article>
            ))}
          </section>
          <aside className="space-y-4">
            <h2>ORDER SUMMARY</h2>
            <p>
              <span>Merchandise</span>
              <b>{money(subtotal)}</b>
            </p>
            <p>
              <span>Flat-rate shipping</span>
              <b>{freight ? money(freight) : "COMPLIMENTARY"}</b>
            </p>
            <div>
              <span>ESTIMATED TOTAL</span>
              <b>{money(subtotal + freight)}</b>
            </div>
            <button onClick={() => go("checkout")}>
              CONTINUE TO CHECKOUT ↗
            </button>
            <div className="mt-10 text-[10px] leading-[1.5]">
              Final freight, taxes and delivery dates are confirmed before
              payment.
            </div>
          </aside>
        </div>
      )}
    </main>
  );
}
